// Componente Deudas.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6"> </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datadeuda"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>

                  <el-table-column label="" min-width="100px" align="center">
                      <template >
                        <b-button size="sm" variant="primary" @click="recuperar_detdeuda()">Detalle</b-button>
                      </template>
                  </el-table-column>
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Deuda"
      cancel-title="Cancelar"
      v-model="modaldetdeuda"
      @cancel="modaldetdeuda = false"
    >
    <b-row class="my-1">
      <b-col sm="6"></b-col>
      <b-col sm="6">
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            size="sm"
            id="filtroNombre"
            type="text"
            placeholder="Buscar"
            v-model="filters[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="datadetdeuda"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titlesdetdeuda"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">

                <template slot-scope="scope">
                  <div v-if="title.prop == 'numero'">  
                    <b-link type="text" 
                            v-if="scope.row.numero > 0  &&  scope.row.tipo == 'F'"
                            @click="selecciona_factura(scope.row.numero)"
                            >
                      {{scope.row.numero}}
                    </b-link>
                    <b-link type="text" 
                            v-if="scope.row.numero > 0  &&  scope.row.tipo == 'M'"
                            @click="selecciona_movimiento(scope.row.numero)"
                            >
                      {{scope.row.numero}}
                    </b-link>
                    <!-- <p v-else >{{scope.row.numero}}</p> -->
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                </template>
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      :title="titlemodalFactura"
      cancel-title="Cancelar"
      v-model="modalfactura"
      @cancel="modalfactura = false"
    >
    <b-row>
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="1">
            <label>Numero:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.numerofac" ></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>
          
          <b-col sm="1">
            <label>Deudor:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.deudorfac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>

          <b-col sm="1">
            <label>Tipo:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.tipofac"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="1">
            <label>Sucursal:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.sucursalfac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>
          
          <b-col sm="1">
            <label>Moneda:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.monedafac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>

          <b-col sm="1">
            <label>Cambio:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.cambiofac"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="1">
            <label>Neto:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.netofac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>
          
          <b-col sm="1">
            <label>Exento:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.excentofac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>

          <b-col sm="1">
            <label>Iva:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.ivafac"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="1">
            <label>Emitida:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.emitidafac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>
          
          <b-col sm="1">
            <label>Generada:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.generadafac"></b-form-input>
          </b-col>
          <b-col sm="1"></b-col>

          <b-col sm="1">
            <label>Pagada:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.pagadafac" ></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    
    </b-row>  
    <br>

    <b-row>
      <b-col lg="12">
      <b-card>
        <div slot="header">
          <strong>Detalle de factura</strong>
        </div>
        <div>
          <b-col lg="12">             
            <div ref="refTable2">
              <data-tables ref="refTable2"
                :data="datadetfactura"
                name="table1"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table">
                <el-table-column
                  v-for="title in titlesdetfactura"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive">
                </el-table-column>
                
                <el-table-column  label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <b-button size="sm" variant="primary" @click="selecciona_movimiento(scope.row.numero)" >Movimiento</b-button>
                  </template>
                </el-table-column>
              
              </data-tables>
            </div>
            
          </b-col>
        
        </div>
      </b-card>
      </b-col>
    </b-row>  
  </b-modal>

  <b-modal
      size="xl"
      scrollable
      hide-footer
      :title="titlemodalMov"
      cancel-title="Cancelar"
      v-model="modalmovimiento"
      @cancel="modalmovimiento = false"
    >
    <b-row>
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="2">
            <label>Sis Número:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.sisnumero" ></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Persona:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.personamov"></b-form-input>
          </b-col>

          <b-col sm="2">
            <label>Tipo Persona:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.tipopersona"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="2">
            <label>Clase:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.clasemov"></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Fecha:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.fechamov"></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Fecha Vencimiento:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.fevencimientomov"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="2">
            <label>Moneda:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:center;" size="sm" disabled v-model="datosFormulario.monedamov"></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Monto Neto:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.netomov"></b-form-input>
          </b-col>
        
          <b-col sm="2">
            <label>Impuesto:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.impuestomov"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col sm="2">
            <label>Descuento Bruto:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.decuentobrutomov"></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Exento:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.exentomov"></b-form-input>
          </b-col>
          
          <b-col sm="2">
            <label>Sucursal:</label>
          </b-col>
          <b-col sm="2">
            <b-form-input style="text-align:right;" size="sm" disabled v-model="datosFormulario.sucursalmov" ></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    
    </b-row>  
    <br>

    <b-row>
      <b-col lg="12">
      <b-card>
        <div slot="header">
          <strong>Detalle Movimiento</strong>
        </div>
        <div>
          <b-col lg="12">             
            <div ref="refTable2">
              <data-tables ref="refTable2"
                :data="datadetmovimiento"
                name="table1"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table">
                <el-table-column
                  v-for="title in titlesdetmovimiento"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive">

                  <template slot-scope="scope">
                  <div v-if="title.prop == 'nuvin'">  
                    <b-link type="text" 
                            v-if="scope.row.nuvin > 0" 
                            @click="selecciona_movimiento(scope.row.nuvin)"
                            >
                      {{scope.row.nuvin}}
                    </b-link>
                    <p v-else >{{scope.row.nuvinS}}</p>
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                  </template>

                </el-table-column>
              </data-tables>
            </div>
            
          </b-col>
        
        </div>
      </b-card>
      </b-col>
    </b-row>  
  </b-modal>

  
  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Deudas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    cod_asegurado: Number,
    participacion: Number,
    
  },

  data: function() {
    return {
      datadeuda:[],
      datadetdeuda:[],
      datafactura:[],
      datadetfactura:[],
      datamovimiento:[],
      datadetmovimiento:[],

      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetdeuda: false,
      modalfactura: false,
      modalmovimiento: false,

      titlemodalFactura: "",
      titlemodalMov: "",
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },

      datosFormulario: {
        numerofac:"", 
        deudorfac:"",
        tipofac:"",
        sucursalfac:"",
        monedafac:"",
        cambiofac:"",
        netofac:"",
        exentofac:"",
        ivafac:"",
        generadafac:"",
        pagadafac:"",
        numeromov:"",
        personamov:"",
        tipopersona:"",
        clasemov:"",
        fechamov:"",
        fevencimientomov:"",
        monedamov:"",
        netomov:"",
        impuestomov:"",
        decuentobrutomov:"",
        exentomov:"",
        sucursalmov:"",
        estado:"",
      },
      
      titles: [
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "deuda",
          label: "Deuda",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "en_pesos",
          label: "Deuda en Pesos",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "nombre",
          label: "Nombre",
          align: "left",
          minwidth:'200'
        }
        
      ],

      titlesdetdeuda: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "tipo",
          label: "Tipo",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "numero",
          label: "Número",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "deuda",
          label: "Deuda",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "en_pesos",
          label: "Deuda en Pesos",
          align: "right",
          minwidth:'100'
        }
        
      ],

      titlesdetfactura: [
        {
          prop: "linea",
          label: "Línea",
          align: "left",
          minwidth:'80'
        },
        {
          prop: "glosa",
          label: "Glosa",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "numero",
          label: "Número",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "mtobruto",
          label: "Monto Bruto",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "mtoexento",
          label: "Monto Exento",
          align: "right",
          minwidth:'100'
        }      
        
      ],

      titlesdetmovimiento: [
        {
          prop: "numovto",
          label: "Número Mov",
          align: "left",
          minwidth:'80'
        },
        {
          prop: "nuvin",
          label: "Numero Vin",
          align: "left",
          minwidth:'80'
        },
        {
          prop: "fevin",
          label: "Fecha Vin",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "mtomovto",
          label: "Monto Mov",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "mtovin",
          label: "Monto Vin",
          align: "right",
          minwidth:'100'
        }      
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {
    
    customButtonsForRow(row) {
      var botones = new Array();
          
      var obj = new Object();
        obj.tooltip = "Detalle Deuda";
        obj.id = 1;
        obj.name=" Detalle";
        obj.icon = "fa fa-search";
        obj.type = "success";
        obj.handler= _ => {
          this.$session.start();
          this.recuperar_detdeuda();
          }
          botones.push(obj);
          
        return botones;
    },
    
    customButtonsForRowMov(p_movimiento) {
      
      // console.log(p_movimiento);

      var botones = new Array();
      var obj = new Object();
        obj.tooltip = "Movimiento";
        obj.id = 1;
        obj.name=" Movimiento";
        obj.icon = "fa fa-search";
        obj.type = "success";
        obj.handler= _ => {
          this.$session.start();
          this.selecciona_movimiento(p_movimiento);
          }
          botones.push(obj);
          
        return botones;
    },

    formatter(row, column) {
      if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_deuda() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_deuda(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado,
          this.participacion
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datadeuda = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detdeuda() {
         
      this.$Progress.start(); 
      return apiConsultaCliente
          .recuperar_detdeuda(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.cod_asegurado
            )  
            .then(response => {
              this.modaldetdeuda = true;            
              response.data = this.keysMinuscula(response.data);
              this.datadetdeuda = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

    selecciona_factura(p_factura){
        this.recuperar_factura(p_factura);
        this.recuperar_detfactura(p_factura);
        this.modalfactura = true;
    },

    recuperar_factura(p_factura) {
        this.$Progress.start(); 
        return apiConsultaCliente
          .recuperar_factura(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_factura
            )  
            .then(response => {
              response.data = this.keysMinuscula(response.data);
                var datafactura = response.data.res;
                for (var i = 0; i < datafactura.length; i++) {
                  this.datosFormulario.numerofac = datafactura[i]["nufactura"];
                  this.datosFormulario.deudorfac = datafactura[i]["deudor"];
                  this.datosFormulario.tipofac = datafactura[i]["tipo"];
                  this.datosFormulario.sucursalfac = datafactura[i]["sucursal"];
                  this.datosFormulario.monedafac = datafactura[i]["moneda"];
                  this.datosFormulario.cambiofac = datafactura[i]["cambio"];
                  this.datosFormulario.netofac = datafactura[i]["neto"];
                  this.datosFormulario.exentofac = datafactura[i]["exento"];
                  this.datosFormulario.ivafac = datafactura[i]["iva"];
                  this.datosFormulario.emitidafac = datafactura[i]["feemision"];
                  this.datosFormulario.generadafac = datafactura[i]["fegeneracion"];
                  this.datosFormulario.pagadafac = datafactura[i]["fepago"];
                  this.datosFormulario.estado = datafactura[i]["estado"];

                  this.titlemodalFactura = "Factura Nº " + this.datosFormulario.numerofac + ", " + this.datosFormulario.estado;

                }
                

              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

    recuperar_detfactura(p_factura) {
        this.$Progress.start(); 
        return apiConsultaCliente
          .recuperar_detfactura(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_factura
            )  
            .then(response => {

              response.data = this.keysMinuscula(response.data);
              this.datadetfactura = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

    selecciona_movimiento(p_movimiento){
        this.recuperar_movimiento(p_movimiento);
        this.recuperar_detmovimiento(p_movimiento);
        this.modalmovimiento = true;
    },

    recuperar_movimiento(p_movimiento) {
        this.$Progress.start(); 
        return apiConsultaCliente
          .recuperar_movimiento(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_movimiento 
            )  
            .then(response => {

              response.data = this.keysMinuscula(response.data);
              

              response.data = this.keysMinuscula(response.data);
                
                var datamovimiento = response.data.res;
                for (var i = 0; i < datamovimiento.length; i++) {
                  this.datosFormulario.numeromov = datamovimiento[i]["numovto"];
                  this.datosFormulario.vinculado = datamovimiento[i]["vinculado"];
                  this.datosFormulario.sisnumero = datamovimiento[i]["sisnumero"];
                  this.datosFormulario.personamov = datamovimiento[i]["persona"];
                  this.datosFormulario.tipopersona = datamovimiento[i]["tipopersona"];
                  this.datosFormulario.clasemov = datamovimiento[i]["clase"];
                  this.datosFormulario.fechamov = datamovimiento[i]["femovto"];
                  this.datosFormulario.fevencimientomov = datamovimiento[i]["fevenc"];
                  this.datosFormulario.monedamov = datamovimiento[i]["moneda"];
                  this.datosFormulario.netomov = datamovimiento[i]["mtoneto"];
                  this.datosFormulario.impuestomov = datamovimiento[i]["impuesto"];
                  this.datosFormulario.decuentobrutomov = datamovimiento[i]["desctobruto"];
                  this.datosFormulario.exentomov = datamovimiento[i]["exento"];
                  this.datosFormulario.sucursalmov = datamovimiento[i]["sucursal"];

                  this.titlemodalMov = "Movimiento Nº " + this.datosFormulario.numeromov + ", " + this.datosFormulario.vinculado;

                }



              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

    recuperar_detmovimiento(p_movimiento) {
        this.$Progress.start(); 
        return apiConsultaCliente
          .recuperar_detmovimiento(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_movimiento
            )  
            .then(response => {

              response.data = this.keysMinuscula(response.data);
              this.datadetmovimiento = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
    },

  },

  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_deuda();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>